import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Langue } from "app/models/langue";

@Injectable()
export class LangueService {
  private url = `/api/langue`;
  constructor(private http: HttpClient) {}
  public getAll(): Observable<[Langue]> {
    const params = new HttpParams();
    return this.http.get<[Langue]>(this.url, { params: params });
  }
  /**
   * create a  new voie dabord catheter
   * @param type voiedabord
   */
  create(langue: Langue) {
    return this.http.post(this.url, langue).map(data => {
      console.log(data);
    });
  }
  /**
   * supprimer voie dabord catheter
   * @param type voiedabord
   */
  delete(langue: Langue) {
    return this.http.delete(`${this.url}/${langue.id}`).map(data => {
      console.log(data);
    });
  }
  /**
   *modifier voir dabord catheter
   * @param type voiedabord
   */
  update(langue: Langue) {
    return this.http.put(`${this.url}/${langue.id}`, langue).map(data => {
      console.log(data);
    });
  }
  get(id: Number): Observable<Langue> {
    return this.http.get<Langue>(`${this.url}/${id}`);
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/langue.service.ts